import React, { useEffect, useState } from 'react';
import { PillButton } from '../pill-button/pill-button';
import classNames from 'classnames';
export function PillButtonGroup(_a) {
    var buttons = _a.buttons, onClick = _a.onClick, _b = _a.type, type = _b === void 0 ? 'radio' : _b, _c = _a.square, square = _c === void 0 ? false : _c, _d = _a.backgroundColour, backgroundColour = _d === void 0 ? 'link-text' : _d, _e = _a.textColour, textColour = _e === void 0 ? 'headings' : _e, _f = _a.activeTextColour, activeTextColour = _f === void 0 ? 'contrast-text' : _f, icon = _a.icon, layout = _a.layout;
    var _g = useState(buttons), pillButtons = _g[0], setPillButtons = _g[1];
    useEffect(function () { return setPillButtons(buttons); }, [buttons]);
    function activateRadioPillButton(button) {
        setPillButtons(function (currentState) {
            var nextState = structuredClone(currentState);
            nextState.forEach(function (temp) {
                if (!!button.id || button.id === 0) {
                    temp.active = button.id === temp.id;
                    return;
                }
                temp.active = button.slug === temp.slug;
            });
            onClick(nextState.filter(function (temp) { return temp.active; }));
            return nextState;
        });
    }
    function activateCheckboxPillButton(button) {
        setPillButtons(function (currentState) {
            var nextState = structuredClone(currentState);
            nextState.forEach(function (temp) {
                if (!!button.id || button.id === 0) {
                    if (button.id === temp.id)
                        temp.active = !temp.active;
                    return;
                }
                if (button.slug === temp.slug)
                    temp.active = !temp.active;
            });
            onClick(nextState.filter(function (temp) { return temp.active; }));
            return nextState;
        });
    }
    function onClickHandler(button) {
        if (type === 'radio')
            activateRadioPillButton(button);
        if (type === 'checkbox')
            activateCheckboxPillButton(button);
    }
    return (React.createElement("div", { className: classNames("pillButtonsContainer", "kplr_pillButtonGroupWrapper", layout) }, pillButtons.map(function (button) {
        var _a;
        return (React.createElement(PillButton, { key: (_a = button.id) !== null && _a !== void 0 ? _a : button.slug, id: button.id, slug: button.slug, label: button.label, active: button.active, square: square, backgroundColour: backgroundColour, textColour: textColour, activeTextColour: activeTextColour, icon: icon, onClick: onClickHandler }));
    })));
}
export default PillButtonGroup;
